module.exports = __webpack_public_path__ + "static/media/ils-file-pdf.68de9eaf.svg";